__turbopack_context__.v({
  "maskIcon": "index-module-scss-module__RY-J9q__maskIcon",
});
